import React, { FC } from 'react';
import { Column } from '../../../../models/Project';
import MarkAs from './MarkAs';
import More from './More';
import styles from './styles.module.css';
import cx from 'classnames';

type Props = {
  taskMoveToProject: boolean;
  taskDelete: boolean;
  taskEditStatus: boolean;
  container: HTMLDivElement;
  columns: Column[];
  column: Column;
  projectId: number;
  shareUrl: string;
  updateTask: (
    columnOrStatus:
      | Column
      | { statusId?: number | null; columnId: number | null }
  ) => any;
  isSmallDetailsView?: boolean;
  isAdminView?: boolean;
  hideDivider?: boolean;
  moveToProject: (projectId: number, domEvent?: any) => void;
  deleteTask: (
    onError?: (error: Error) => void,
    onSuccess?: () => void
  ) => void;
  isNewSidebar?: boolean;
};

const TaskActions: FC<Props> = ({
  taskMoveToProject,
  taskDelete,
  taskEditStatus,
  container,
  columns,
  column,
  projectId,
  shareUrl,
  updateTask,
  isSmallDetailsView,
  isAdminView,
  hideDivider,
  moveToProject,
  deleteTask,
  isNewSidebar
}) => {
  return (
    <div
      className={cx(styles.actionContainer, {
        [styles.adminContainer]: isAdminView,
        [styles.noDivider]: hideDivider
      })}
    >
      <MarkAs
        columns={columns}
        column={column}
        updateStatus={(
          columnOrStatus:
            | Column
            | { statusId: number | null; columnId: number | null }
        ) => updateTask(columnOrStatus)}
        container={container}
        taskEditStatus={taskEditStatus}
        isNewSidebar={isNewSidebar}
        isAdminView={isAdminView}
      />
      <div
        className={cx(styles.moreActionsContainer, {
          [styles.moreActionsSmallView]: isSmallDetailsView || !isAdminView
        })}
      >
        <More
          isAdminView={isAdminView}
          container={container}
          projectId={projectId}
          taskDelete={taskDelete}
          taskMoveToProject={taskMoveToProject}
          shareUrl={shareUrl}
          moveToProject={moveToProject}
          deleteTask={deleteTask}
          isNewSidebar={isNewSidebar}
        />
      </div>
    </div>
  );
};

export default TaskActions;
